import * as React from 'react';
import styled from 'styled-components';

import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryImageUrlByImageNumber,
    getItemSummaryTitle,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { addImageParams } from '@/utils/urls';

type Props = {
    imageIndex: number;
    imageNumber: number;
    itemId: number;
};

const CarouselPhoto = ({ imageIndex, imageNumber, itemId }: Props) => {
    const title = useAppSelector((state) => getItemSummaryTitle(state, itemId));
    const alt = imageIndex ? `${title} - ${imageIndex + 1}` : title;
    const photoUrl = useAppSelector((state) => getItemSummaryImageUrlByImageNumber(state, itemId, imageNumber));
    const imageUrl = addImageParams({ url: photoUrl, width: 500 });

    return (
        <Container>
            <PrimaryImage
                alt={alt}
                src={imageUrl}
            />
        </Container>
    );
};

export default CarouselPhoto;

const Container = styled.div`
    max-height: 100%;
    height: 420px;
    justify-content: center;
    display: flex !important;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    position: relative;

    @media (max-width: 375px) {
        height: 400px;
    }
`;

const PrimaryImage = styled.img`
    max-height: 100%;
    max-width: calc(100% - 2px);
    z-index: 1;

    @media (max-width: 320px) {
        max-height: 320px;
    }
`;
